jQuery(function($){
	$('.co-tile-wrapper').on('click', '.co-tile.availability .availability-status', function(){
		let parentWrapper = $(this).closest('.co-tile-wrapper');
		let memberTile = $(this).closest('.co-tile');

		let wasExpanded = memberTile.hasClass('expanded');

		$('.co-tile.availability').each(function(){
			$(this).removeClass('expanded');
		});

		if(!wasExpanded) memberTile.addClass('expanded');
	});

	$('.co-tile-wrapper').on('click', '.co-tile.availability .availability-status-update .update-button', function(){
		console.log(this.classList);
		let parentWrapper = $(this).closest('.co-tile-wrapper');
		let memberTile = $(this).closest('.co-tile');

		let buttonStatus = $(this).attr('status');
		let commentsDiv = $(this).closest('.availability-status-update').find('.comments');

		memberTile.removeClass('expanded going maybe not_going no_answer').addClass(buttonStatus);

		let comments = '';
		$.each(commentsDiv, function(index, div){
			comments += $(this).val();
		});
		console.log(comments);

		let partColumn = $(this).closest('.part');
		let part = memberTile.attr('part');

		let memberId = memberTile.attr('member_id');
		let eventId = memberTile.attr('event_id');
		let memberStatus = memberTile.attr('status');

		let toColumn = '.responses .part[part=' + part + '] .status[status=' + buttonStatus + ']';

		let data = {
			action: 'choralorg_availability_update_record',
			member_id: memberId,
			event_id: eventId,
			comments: comments,
			status: buttonStatus
		};

		console.log(data);

		if(buttonStatus == 'no_answer') {
			data.remove = true;
			toColumn = '.uncounted-members .part[part=' + part + '] .status[status=' + memberStatus + ']';
		}

		$(toColumn).each(function(){
			addToColumn($(this), memberTile, toColumn);
		});

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			memberTile.find('.subtitle .status').html(response);
		});

		updateAttendanceTotals();
	});

	function addToColumn(column, memberTile, toColumn) {
		memberTile.detach().appendTo(toColumn);
		sortToColumn(column);
	}

	function sortToColumn(column) {
		columnItems = [];
		column.find('.co-tile').each(function(){
			columnItems.push({
				first_name: $(this).attr('first_name'),
				last_name: $(this).attr('last_name'),
				el: $(this)
			});
			$(this).remove();
		});

		columnItems.sort(sortByName);
		$.each(columnItems, function(index, value){
			column.append(value.el);
		});
	}

	function sortByName(a, b) {
		let keys = [
			'last_name',
			'first_name'
		];

		let returnValue = 0;
		$.each(keys, function(index, value){
			returnValue = compareValues(a, b, value);
			if(returnValue != 0) return false;
		});
		return returnValue;		
	}

	function compareValues(a, b, key) {
		if(a[key] < b[key]) return -1;
		if(a[key] > b[key]) return 1;
		return 0;		
	}

	function updateAttendanceTotals() {
		let totals = {
			going: 0,
			maybe: 0,
			not_going: 0
		};

		let statusName;

		$('.column-attendance-total').each(function(){
			let parentDiv = $(this).closest('.status');
			let total = parentDiv.find('.co-tile').length;

			statusName = parentDiv.attr('status');

			if(total > 0) {
				parentDiv.removeClass('empty');
			} else {
				parentDiv.addClass('empty');
			}

			$(this).html(total);

			totals[statusName] += total;
		});

		$.each(totals, function(key, value){
			$('.list-stats .list-stat.' + key + ' .count').html(value);
		});
	}

	$('.co-tile .log-button').on('click', function(){
		const target = $(this).attr('popup_target');
		$(this).closest('.co-tile').find('.log-modal[popup_id="' + target + '"]').addClass('showing');
	});

	$('.co-tile .log-modal .log-modal-bg').on('click', function(){
		closeAttendanceLogModal($(this));
	});

	function closeAttendanceLogModal(el) {
		el.closest('.log-modal').removeClass('showing');
	} 
});